import { AdornmentRight } from './AdornmentRight';

// TODO: in v9, move styled() from AdornmentRight.jsx to here
export var StyledAdornmentRight = AdornmentRight;